/**
 * Play Space Brain Customer Portal — theme colors
 * Palette grounded in the brand mark: ink navy (#1D1C2A) + brewed gold (#EFCC00).
 * Deep gold is the single interactive/accent color (drives MUI "primary" and "info",
 * which together cover most buttons and links in this app). Bright brand-gold is
 * reserved for small high-energy accents. Navy carries "secondary" actions and headings.
 */

const colors = {
  background: {
    default: "#FBF7EE",
  },

  text: {
    main: "#615E78",
    focus: "#4A4760",
  },

  transparent: {
    main: "transparent",
  },

  white: {
    main: "#ffffff",
    focus: "#ffffff",
  },

  black: {
    light: "#000000",
    main: "#000000",
    focus: "#000000",
  },

  primary: {
    main: "#B9860F",
    focus: "#8F6608",
  },

  secondary: {
    main: "#1D1C2A",
    focus: "#2C2A40",
  },

  info: {
    main: "#B9860F",
    focus: "#8F6608",
  },

  successBk: {
    main: "#DCEAE3",
    focus: "#DCEAE3",
  },

  success: {
    main: "#2F6F5E",
    focus: "#255A4C",
  },

  warning: {
    main: "#B8562E",
    focus: "#9C4726",
  },

  error: {
    main: "#A33F3B",
    focus: "#8A342F",
  },

  light: {
    main: "#FBF7EE",
    focus: "#F3EDE0",
  },

  dark: {
    main: "#1D1C2A",
    focus: "#2C2A40",
  },

  grey: {
    100: "#F7F6FA",
    200: "#F0EEF5",
    300: "#E1DEEA",
    400: "#C7C3D6",
    500: "#A7A2BC",
    600: "#86819C",
    700: "#615E78",
    800: "#423F58",
    900: "#2C2A40",
  },

  gradients: {
    primary: {
      state: "#B9860F",
      main: "#EFCC00",
    },

    secondary: {
      main: "#615E78",
      state: "#423F58",
    },

    info: {
      main: "#B9860F",
      state: "#B9860F",
    },

    success: {
      main: "#2F6F5E",
      state: "#2F6F5E",
    },

    warning: {
      main: "#B8562E",
      state: "#B8562E",
    },

    error: {
      main: "#A33F3B",
      state: "#8A322E",
    },

    light: {
      main: "#FBF7EE",
      state: "#E4DFD3",
    },

    dark: {
      main: "#1D1C2A",
      state: "#0F0E16",
    },
  },

  socialMediaColors: {
    facebook: {
      main: "#3b5998",
      dark: "#344e86",
    },

    twitter: {
      main: "#55acee",
      dark: "#3ea1ec",
    },

    instagram: {
      main: "#125688",
      dark: "#0e456d",
    },

    linkedin: {
      main: "#0077b5",
      dark: "#00669c",
    },

    pinterest: {
      main: "#cc2127",
      dark: "#b21d22",
    },

    youtube: {
      main: "#e52d27",
      dark: "#d41f1a",
    },

    vimeo: {
      main: "#1ab7ea",
      dark: "#13a3d2",
    },

    slack: {
      main: "#3aaf85",
      dark: "#329874",
    },

    dribbble: {
      main: "#ea4c89",
      dark: "#e73177",
    },

    github: {
      main: "#24292e",
      dark: "#171a1d",
    },

    reddit: {
      main: "#ff4500",
      dark: "#e03d00",
    },

    tumblr: {
      main: "#35465c",
      dark: "#2a3749",
    },
  },

  badgeColors: {
    primary: {
      background: "#F3E2B8",
      text: "#8F6608",
    },

    secondary: {
      background: "#E1DEEA",
      text: "#423F58",
    },

    info: {
      background: "#F3E2B8",
      text: "#8F6608",
    },

    success: {
      background: "#D7ECE4",
      text: "#255A4C",
    },

    warning: {
      background: "#F1D9CB",
      text: "#9C4726",
    },

    error: {
      background: "#F0D6D5",
      text: "#8A342F",
    },

    light: {
      background: "#FBF7EE",
      text: "#86819C",
    },

    dark: {
      background: "#2C2A40",
      text: "#F7F6FA",
    },
  },

  coloredShadows: {
    primary: "#B9860F",
    secondary: "#1D1C2A",
    info: "#B9860F",
    success: "#2F6F5E",
    warning: "#B8562E",
    error: "#A33F3B",
    light: "#A7A2BC",
    dark: "#2C2A40",
  },

  inputBorderColor: "#E1DEEA",

  tabs: {
    indicator: { boxShadow: "#E1DEEA" },
  },
};

export default colors;
